import $ from "jquery";
import {GoingUtils,AssertUtils} from "goingutils";
import GoTabUrl from "../goTabsUrl";
import  dhtmlXTreeObject from '../../../dx/dxSource/components/dhtmlXTreeObject';

let departPanelUtils = {
    selectedTreeNode(cellObj) {
        //如果该树可以进行选择操作
        if (cellObj.itemConfig["orgSel"]) {
            cellObj.alreadySelGrid.forEachRow(function (id) {
                //如果存在记录 则进行选中
                if (!cellObj.departTreeObj.isItemChecked(id)) {
                    cellObj.departTreeObj.setCheck(id, true);
                }
            });
        }
    },
    /**
     * 加载部门树 数据信息
     * @param accountId
     * @param cellObj
     */
    _loadDepartTree({accountId = ""}, cellObj) {
        //如果没有传账套id  则根据super账套id进行查询
        if (!AssertUtils.isNotEmpty(accountId)) {
            if (cellObj.accountTreeObj != null) {
                accountId = cellObj.accountTreeObj.getSelectedItemId();
            }
        }
        //如果账套不能选择 而又没有传入账套id 则取当前用户的账套id
        if (cellObj.itemConfig["accountSel"] === false && !AssertUtils.isNotEmpty(accountId)&&window.CurrentUtils._getCurrentUser()!=null) {
            accountId = window.CurrentUtils._getCurrentUser()["account_id"];
        }
        //如果部门树存在 则根据账套id进行查询
        if (cellObj.departTreeObj != null) {
            //查询机构树信息
            let depatName = $(`#${cellObj.tabId}_search_input_text`).val() || "";
            cellObj.departTreeObj.flushTreeByUrl({
                params: {name: depatName},
                url: GoTabUrl.getOrgTreeByAccountId(accountId),
                backFun: function (orgTreeObj, backDs) {
                    if(backDs==null){
                        return void(0);
                    }
                    if (backDs&&backDs.length > 0) {
                        orgTreeObj.openAllItems(backDs[0][1]);
                    }
                    //    如果待选数据中存在数据 而且是可选状态 则需要将相应记录进行反选
                    departPanelUtils.selectedTreeNode(cellObj);
                }
            });
        }

    },
    /**
     * 选择树节点 将数据添加到已选表格中
     * @param nodeId
     * @param cellObj
     */
    addTreeNodeToAlreadyGrid(departTreeObj, cellObj) {
        let alreadyGrid = cellObj.alreadySelGrid;
        //如果存在已选数据的表格对象
        if (alreadyGrid != null) {
            let ids = departTreeObj.getAllChecked();
            ids.split(",").forEach(function (nodeId) {
                //如果不存在 则进行增加 如果存在 则不进行增加
                if (alreadyGrid.getRowIndex(nodeId) < 0 && AssertUtils.isNotEmpty(nodeId)&&!cellObj.skipIds.includes(nodeId)) {
                    let datas=["", departTreeObj.getItemText(nodeId), "", '部门','depart'];
                    alreadyGrid.addRow(nodeId,datas);
                }
            });
        }
    },
    /**
     * 初始化部门树选择事件
     * @param cellObj
     * @param orgTreeObj
     * @private
     */
    _initTreeSelEvent(cellObj, orgTreeObj, checkRelFlag = true) {
        //判断是否为单选  如果单选则采用radio模式
        if (cellObj.goTabs["count"] === 1) {
            orgTreeObj.enableRadioButtons(true);
            orgTreeObj.enableSingleRadioMode(true);
            //点击onCheck事件后， 循环打勾的数据添加到已选数据里面
            orgTreeObj.attachEvent("onCheck", function () {
                //如果是单选 清空以前到数据
                let alreadyGrid = cellObj.alreadySelGrid;
                alreadyGrid.clearAll();
                departPanelUtils.addTreeNodeToAlreadyGrid(orgTreeObj, cellObj);
            });
        } else {
            //如果为多选 则采用checkBox模式
            orgTreeObj.enableCheckBoxes(1);
            orgTreeObj.enableThreeStateCheckboxes(checkRelFlag);
            //如果原先是选中 从选中变成不选中的时候 需要删除以前的数据
            orgTreeObj.attachEvent("onBeforeCheck", function (id) {
                var checkState = orgTreeObj.isItemChecked(id);
                if (checkState) {
                    let ids = orgTreeObj.getAllChecked();
                    ids.split(",").forEach(function (item) {
                        cellObj.delRecordFromAlreadyGrid(item);
                    });
                }
                return true;
            });
            //点击onCheck事件后， 循环打勾的数据添加到已选数据里面
            orgTreeObj.attachEvent("onCheck", function () {
                departPanelUtils.addTreeNodeToAlreadyGrid(orgTreeObj, cellObj);
            });
        }
    },
    /**
     * 初始化部门树
     * @param cellObj
     * @param onClickFun
     * @private
     */
    _initDepartTree(cellObj, dataFrom = "depart",dataFromLabel='部门') {
        let orgTreeObj = new dhtmlXTreeObject(
            cellObj.tabId + "_tree",
            "100%",
            "100%",
            0
        );
        //如果该树可以进行选择操作
        if (cellObj.itemConfig["orgSel"]) {
            departPanelUtils._initTreeSelEvent(cellObj, orgTreeObj, cellObj.itemConfig["checkRelFlag"]);
        }
        //注册树事件
        orgTreeObj.attachEvent("onClick", function (id) {
            //取消选择全集团的操作
            cellObj.dataFrom=dataFrom;
            cellObj.dataFromLabel=dataFromLabel;
            departPanelUtils.onClickFun(id, cellObj, orgTreeObj);
            return true;
        });
        return orgTreeObj;
    },
    /**
     * 部门点击事件
     * @param id
     * @param cellObj
     * @param treeObj
     * @param pageType
     */
    onClickFun(id, cellObj, treeObj) {
        if (cellObj.itemConfig["orgSel"] && cellObj.tabIdName !== "departUser") {
            if (cellObj.goTabs["count"] === 1) {
                //如果是单选 清空以前到数据
                let alreadyGrid = cellObj.alreadySelGrid;
                alreadyGrid.clearAll();
                //执行radio选择操作
                departPanelUtils._executeRadioSel(treeObj, cellObj, id);
            } else {
                //执行checkbox选择操作
                departPanelUtils._executeCheckSel(treeObj, cellObj, id);
            }
        } else {
            departPanelUtils._notSelTreeNode(cellObj);
        }
    },
    /**
     * 执行radio选择操作
     * @param treeObj
     * @param cellObj
     * @param id
     * @private
     */
    _executeRadioSel(treeObj, cellObj, id) {
        let ids = treeObj.getAllChecked();
        //删除以前选择的所有记录
        ids.split(",").forEach(function (item) {
            cellObj.delRecordFromAlreadyGrid(item);
        });
        //根据当前的选择状态 添加或者删除相应节点
        var checkState = treeObj.isItemChecked(id);
        //设置树节点的checkbox状态
        treeObj.setCheck(id, !checkState);
        //如果checkState为true则表示取消打勾操作
        if (GoingUtils.parseBoolean(checkState)) {
            cellObj.delRecordFromAlreadyGrid(id);
        } else {
            departPanelUtils.addTreeNodeToAlreadyGrid(treeObj, cellObj);
        }
    },
    /**
     * 执行checkbox选择操作
     * @param treeObj
     * @param cellObj
     * @param id
     * @private
     */
    _executeCheckSel(treeObj, cellObj, id) {
        let ids = treeObj.getAllChecked();
        var checkState = treeObj.isItemChecked(id);
        //设置树节点的checkbox状态
        treeObj.setCheck(id, !checkState);
        //如果checkState为true则表示取消打勾操作
        if (checkState) {
            //删除该节点 以及该节点下的所有子节点
            ids.split(",").forEach(function (item) {
                cellObj.delRecordFromAlreadyGrid(item);
            });
        }
        departPanelUtils.addTreeNodeToAlreadyGrid(treeObj, cellObj);
    },
    //如果不可以选择部门信息 则只执行相关查询
    _notSelTreeNode(cellObj) {
        //取消选择全集团的操作
        cellObj.clearSelAllAccount();
        cellObj.searchWaitForUser();
    },
    //获取部门panel 右边视图的html内容
    initRightCellContent(panelHeight, cellObj, width) {
        return cellObj._getRightCellContent(panelHeight, cellObj, width);
    },
    /**
     * 获取部门panel左边区域的头部内容
     * @param tabCell
     * @param treeHeight
     * @param departTreeHeight
     */
    getPanelHeader(tabCell, treeHeight, departTreeHeight, search_label, tabId, groupCheck = false, accountWid = 130, searchInputWid = 135) {
        if (!groupCheck) {
            searchInputWid = 200;
            accountWid = 160;
        }
        return `${tabCell._getLeftPanelCommonTopHeader(accountWid, searchInputWid, search_label, tabCell, groupCheck)}
            <div class="depart-tree-div" style="height: ${treeHeight}">
              <div id="${
            tabCell.tabId
            }_tree" style="height: ${departTreeHeight};overflow: auto;"></div>
            </div>`;
    }
};
export default departPanelUtils;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/components/departCommon.js